export function resolveUrl(path) {
  if (!path) return;
  if (path.startsWith("http")) return path;

  // const baseUrl =
  //   process.env.REACT_APP_BACKOFFICE_API_URL_DEV ||
  //   process.env.REACT_APP_BACKOFFICE_API_URL_PROD;
  const baseUrl = "https://hoteisdigitais-backend.onrender.com/api/v1";
  return `${baseUrl}${path}`;
}
